
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/cafes",
      function () {
        return require("private-next-pages/[region]/[lang]/cafes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/cafes"])
      });
    }
  